import { render, staticRenderFns } from "./CardCongenitalConstitution.vue?vue&type=template&id=e57c0eb4&scoped=true&"
import script from "./CardCongenitalConstitution.vue?vue&type=script&lang=js&"
export * from "./CardCongenitalConstitution.vue?vue&type=script&lang=js&"
import style0 from "./CardCongenitalConstitution.vue?vue&type=style&index=0&id=e57c0eb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57c0eb4",
  null
  
)

export default component.exports